import axios from 'axios';
import authHeader from './auth-header';
import config from '../config';

class ProfileService {
  // Get user profile
  getProfile() {
    return axios.get(config.api.profile, {
      headers: authHeader()
    });
  }

  // Update profile information
  updateProfile(profileData) {
    return axios.put(config.api.profile, profileData, {
      headers: authHeader()
    });
  }

  // Update wallet information
  updateWallet(walletData) {
    return axios.put(config.api.profile + '/wallet', walletData, {
      headers: authHeader()
    });
  }

  // Change login password
  changeLoginPassword(currentPassword, newPassword) {
    return axios.put(config.api.profile + '/security', {
      currentPassword,
      newPassword
    }, {
      headers: authHeader()
    });
  }

  // Change fund password
  changeFundPassword(currentFundPassword, newFundPassword) {
    return axios.put(config.api.profile + '/security/fund', {
      currentFundPassword,
      newFundPassword
    }, {
      headers: authHeader()
    });
  }

  // Verify fund password
  verifyFundPassword(fundPassword) {
    return axios.post(config.api.profile + '/verify-fund-password', {
      fundPassword
    }, {
      headers: authHeader()
    });
  }

  // Get user's site messages
  getSiteMessages() {
    return axios.get(config.api.profile + '/messages', {
      headers: authHeader()
    });
  }

  // Mark message as read
  markMessageAsRead(messageId) {
    return axios.put(config.api.profile + `/messages/${messageId}/read`, {}, {
      headers: authHeader()
    });
  }
}

export default new ProfileService();